import React, { useState } from "react";
import Navigation from "../Navigation";
import "./style.scss";
import SummaryPanel from "./SummaryPanel";
import DataFormPanel from "./DataFormPanel";
import useBasketManager from "../Basket/useBasketManager";
import useDesktopSize from "../../../utils/hooks/useDesktopSize";
import useTypeSale from "../../../utils/hooks/useTypeSale";
import { scrollPageTo } from "../../animations/scrollPageTo";

const FinalizePage: React.FC = () => {
  const { isSaleWithExercise, typeSale } = useTypeSale();
  const { basket, setBasket, categoryBrand, totalListPrice, removeWholeBasket } = useBasketManager(isSaleWithExercise);
  const isDesktop = useDesktopSize();
  const [showDataForm, setShowDataForm] = useState(false);
  const isDataForm = !isDesktop ? showDataForm : true;
  const isSummaryPanel = isDesktop ? isDesktop : !isDataForm;

  const handleNextToForm = () => {
    setShowDataForm(true);
    window.parent.postMessage("scroll::", "*");
    scrollPageTo(0);
  };

  const onPrevSummary = () => {
    setShowDataForm(false);
    scrollPageTo(0);
  };

  return (
    <Navigation>
      <div className={"finalize-panel"}>
        {isSummaryPanel && (
          <SummaryPanel
            basket={basket}
            onRemoveBasket={removeWholeBasket}
            updateBasket={setBasket}
            onNextToForm={() => handleNextToForm()}
            totalListPrice={totalListPrice}
            isSaleWithExercise={isSaleWithExercise}
            typeSale={typeSale}
          />
        )}
        {isDataForm && (
          <DataFormPanel
            onPrevSummary={() => onPrevSummary()}
            basket={basket}
            categoryBrand={categoryBrand}
            typeSale={typeSale}
          />
        )}
      </div>
    </Navigation>
  );
};

export default FinalizePage;
